/** HOF-696 — small display helpers shared by the worker screens and the Timesheet. */

/** 135 → "2:15" (hours:minutes, the way the farm writes hours). */
export function formatMinutes(minutes: number): string {
  const safe = Math.max(0, Math.round(Number.isFinite(minutes) ? minutes : 0));
  return `${Math.floor(safe / 60)}:${String(safe % 60).padStart(2, '0')}`;
}

/** The roster refusals the office can fix, with the reason in plain German (D16). */
export const ACCESS_PROBLEM_LABELS: Record<string, string> = {
  no_phone: 'keine Handynummer auf der Karte',
  phone_shared: 'Nummer bei mehreren Personen',
  office_seat: 'Nummer gehört zu einem Büro-Zugang',
  legacy_invite: 'alte Einladung für die Nummer offen',
  manual_invite: 'Büro-Einladung für die Nummer offen',
};

/** Roster statuses that put a person into the grid (the rest are not workers here). */
export const GRID_STATUSES = new Set(['signed_in', 'pending', 'ended']);

/**
 * Whether a roster row is an access problem the office can fix (D16), and its cause. The server's
 * `problem` flag decides when it is sent: a SUSPENDED seat reports `status: ended` with the cause in
 * `reason` (e.g. `phone_shared`), which a status-only check never listed (HOF-696 ui e2e).
 */
export function accessProblem(person: { status: string; reason?: string; problem?: boolean }): string | null {
  const cause = person.reason && person.reason in ACCESS_PROBLEM_LABELS ? person.reason : person.status;
  if (person.problem === false) return null;
  if (person.problem === true) return ACCESS_PROBLEM_LABELS[cause] ?? ACCESS_PROBLEM_LABELS[person.status] ?? cause;
  return person.status in ACCESS_PROBLEM_LABELS ? ACCESS_PROBLEM_LABELS[person.status] : null;
}
